var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-layout',{attrs:{"title":"Sign In","sidebar-title":"No Account yet?"}},[[_c('closed-notice'),_c('sign-in-form',{staticClass:"px-4 pb-4"})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }